import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Inject, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { MatSort, Sort } from '@angular/material/sort';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';
import { Router } from '@angular/router';
import { AutoDocumentTypeParentService } from 'src/app/core/services/auto-document-type-parent.service';
import { DepartmentService } from 'src/app/core/services/department.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { BlockUI, NgBlockUI } from 'ng-block-ui';



@Component({
  selector: 'app-department-detail',
  templateUrl: './department-detail.component.html',
  styleUrls: ['./department-detail.component.scss']
})
export class DepartmentDetailComponent implements OnInit, AfterViewInit, OnDestroy {


  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "STT", showXS: true, showSM: true, showMD: true },
    { def: "name", showXS: true, showSM: true, showMD: true },
    { def: "email", showXS: true, showSM: true, showMD: true },
    { def: "representative", showXS: true, showSM: true, showMD: true },
    { def: "action", showXS: true, showSM: true, showMD: true },
  ];

  dataSource: DigitalCertificateDataSource;

  department = new Department();
  paginate: Paginate;
  oldData = this.department;
  isFirstLoad = true;
  sortDirection = 'ASC';
  sortColumn = 'fullName';
  isSavingData = false;
  checkAddUser = false;
  checkActive = false;
  error = '';
  userType: any;
  checkFocus = false;
  listUserInDepartment = [];
  userGroup = {
    idString: null,
    code: '',
    name: '',
    description: '',
    listUserInDepartment: [],
    representativeIdString: '',
  };

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChildren('focusInput') focusInput;
  @BlockUI() blockUI: NgBlockUI;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  inputUserValue: string;
  nzCheckLoadingUser = false;
  filteredUserOptions = [];

  constructor(
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private notificationService: NotificationService,
    private router: Router,
    private responsiveService: ResponsiveService,
    private departmentService: DepartmentService,
    public autoDocumentTypeParentData: AutoDocumentTypeParentService,
    public dialogRef: MatDialogRef<DepartmentDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 5,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.userType = localStorage.getItem('userType');
  }
  ngOnInit() {
    this.userGroup.idString = this.data.idString;
    this.oldData.idString = this.data.idString;
    this.checkActive = this.data.status
    // console.log(this.data);
    // load data for first time
    this.loadDataForFirstTime();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);

  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  deleteUserDepartment(data) {
    if (data) {
      this.departmentService.deleteUserInDepartment({ idString: this.oldData.idString, userId: data.id }).subscribe(res => {
        if (res.success) {
          this.onFilterData();
          this.toastr.success(this.message.getMessage('messages.remove_user_department'));
        } else if (res.code === ErrorCode.DataNotfound) {
          this.onFilterData();
          this.toastr.error(this.message.getMessage('messages.remove_user_department_not_found'));
        } else if (res.code === ErrorCode.ContactSystemAdmin) {
          this.onFilterData();
          this.toastr.error(this.message.getMessage(res.message));
        } else {
          this.onFilterData();
          this.toastr.error(this.message.getMessage('messages.remove_user_department_error'));
        }
      });
    }
  }

  close() {
    this.dialogRef.close();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }
    }
  }



  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  loadDataForFirstTime(page: number = 0, pageSize: number = 5) {

    this.dataSource = new DigitalCertificateDataSource();

    this.getSortDirection();

    // this.departmentService.getRepresentativeByDepartmentId(this.userGroup.idString).subscribe(res => {
    //   if (res.success) {
    //     this.data.representativeIdString = res.data;
    //   }
    // })
    this.departmentService.getUsersByDepartment(
      this.getFilterCondition(page, pageSize, this.oldData.nameOrCode, this.oldData.idString))
      .subscribe(response => {
        // console.log(response)
        if (this.responseHaveData(response)) {
          this.initPaginateToDisplay(response);
        }
        if (response.data && response.data.dataRow != null) {
          this.initDataToDisplay(response);
        }
      });
  }

  responseHaveData(response: any): boolean {
    return response.data != null &&
      response.data.currentPage != null &&
      response.data.pageSize != null &&
      response.data.totalRow != null &&
      response.data.totalRow != null;
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 5) {
    this.blockUI.reset();
    this.blockUI.start('');
    this.departmentService.getRepresentativeByDepartmentId(this.userGroup.idString).subscribe(res => {
            if (res.success) {
              this.data.representativeIdString = res.data;
            }
          })
    this.departmentService.getUsersByDepartment(
      this.getFilterCondition(page, pageSize, this.oldData.nameOrCode, this.oldData.idString))
      .subscribe(
        response => {
          this.initPaginateToDisplay(response);
          this.initDataToDisplay(response);
          this.blockUI.stop();
        },
        error => {
          this.blockUI.stop()
        }
      );
  }

  getSortDirection() {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
  }

  initPaginateToDisplay(rs: any) {
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };
  }

  initDataToDisplay(response: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    response.data.dataRow.forEach(parent => {
      parent['STT'] = stt++;
      parent.isRepresentative = this.data.representativeIdString === parent.id;
    });
    // console.log('display', response);
    this.dataSource.setData(response.data.dataRow);
  }

  getFilterCondition(
    page: number, pageSize: number,
    nameOrCode: any = null, idString: any = null
  ): any {

    let filterCondition = {};

    filterCondition = {
      idString: idString,
      nameOrCode: nameOrCode,
      page,
      pageSize,
    };

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;

    switch (sortColumn) {

      case 'taxCode':
        column = {
          taxCode: sortDirection
        };
        break;
      case 'phoneNumber':
        column = {
          phoneNumber: sortDirection
        };
        break;
      case 'typeCertificate':
        column = {
          typeCertificate: sortDirection
        };
        break;
      case 'effectiveDate':
        column = {
          effectiveDate: sortDirection
        };
        break;
      case 'activeDate':
        column = {
          activeDate: sortDirection
        };
        break;
      case 'expireDate':
        column = {
          expireDate: sortDirection
        };
        break;
    }

    filterCondition['sorts'] = column;

    return filterCondition;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortColumn = sort.active;
  }

  //  thay đổi người đại diện
  changeRepresentative(data) {
    
    if (data.id === this.data.representativeIdString) {
      data.id = null
    }

    if (data) {
      this.blockUI.start('');
      this.departmentService.assignRepresentative({ idString: this.userGroup.idString, representativeIdString: data.id }).subscribe(res => {
        console.log(res)
        if (res.success) {
          this.toastr.success(this.message.getMessage(res.message));
        } else if (res.code === ErrorCode.AssignRepresentativeInactive) {
          this.toastr.error(this.message.getMessage(res.message));
        } else if (res.code === ErrorCode.AssignRepresentativeNotFound) {
          this.toastr.error(this.message.getMessage(res.message));
        } else if (res.code === ErrorCode.DataNotfound) {
          this.toastr.error(this.message.getMessage('messages.assign_representative_not_found'));
        } else if (res.code === ErrorCode.ContactSystemAdmin) {
          this.toastr.error(this.message.getMessage(res.message));
        }  else if (res.code === ErrorCode.AssignRepresentativeAlready) {
          this.toastr.error(this.message.getMessage(res.message));
        }else {
          this.toastr.error(this.message.getMessage('messages.update_department_error'));
        };
        this.onFilterData()
        this.blockUI.stop();
      });
    }
  }

  addUser() {
    this.checkAddUser = true;
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.departmentService.getUserByFullNameOrEmail(this.inputUserValue.trim())
        .subscribe(result => {
          this.filteredUserOptions = result.data;
          this.nzCheckLoadingUser = false;
        }, error => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      // const duplicateItem = this.listUserInDepartment.find(item => item.id === model.id);
      let listUser = [];
      listUser.push(model.id);
      this.userGroup.listUserInDepartment = listUser;

      if (this.userGroup.representativeIdString === undefined) {
        this.userGroup.representativeIdString = null;
      }

      this.blockUI.start('');
      this.departmentService.updateUserInDepartment(this.userGroup).subscribe(
        res => {
          if (res.success) {
            this.toastr.success(this.message.getMessage('messages.add_user_department'));
            this.checkActive = true;
            // this.onFilterData()
          } else if (res.code === ErrorCode.DataNotfound) {
            this.toastr.error(this.message.getMessage('messages.add_user_department_not_found'));
            this.dialogRef.close();
            // this.onFilterData();
          } else if (res.code === ErrorCode.DepartmentDeletedOrLocked) {
            this.toastr.error(this.message.getMessage('messages.add_user_department_inactive'));
            this.checkActive =false;
            // this.onFilterData();
          } else if (res.code === ErrorCode.ContactSystemAdmin) {
            this.toastr.error(this.message.getMessage(res.message));
            // this.onFilterData();
          } else if (res.code === ErrorCode.AddUserDepartmentInactive) {
            this.toastr.error(this.message.getMessage(res.message));
            // this.onFilterData();
          }else {
            this.toastr.error(this.message.getMessage('messages.add_user_department_error'));
            // this.onFilterData();
          }
          this.onFilterData()
          this.blockUI.stop()
        })
    }
  }
}

export class Department {
  nameOrCode: any;
  idString: any;
}

export class DigitalCertificateDataSource extends DataSource<Department> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Department[]>([]);

  constructor() {
    super();
  }


  setData(data: Department[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Department[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];

}
